export const timeZone = [
    {
        value: "Alaska",
        lable: "Alaska"
    },
    {
        value: "America/Adak",
        lable: "America/Adak"
    },
    {
        value: "America/Anchorageica",
        lable: "America/Anchorageica"
    },
    {
        value: "America/Boise",
        lable: "America/Boise"
    },
    {
        value: "America/Detriot",
        lable: "America/Detriot"
    },
    {
        value: "America/Menominee",
        lable: "America/Menominee"
    },
    {
        value: "America/Metlakatla",
        lable: "America/Metlakatla"
    },
    {
        value: "America/Nome",
        lable: "America/Nome"
    },
    {
        value: "America/Sitka",
        lable: "America/Sitka"
    },
    {
        value: "America/Yakutat",
        lable: "America/Yakutat"
    },
    {
        value: "America/Indiana/Knox",
        lable: "America/Indiana/Knox"
    },
    {
        value: "America/Indiana/Marengo",
        lable: "America/Indiana/Marengo"
    },
    {
        value: "America/Indiana/Petersburg",
        lable: "America/Indiana/Petersburg"
    },
    {
        value: "America/Indiana/Tell_City",
        lable: "America/Indiana/Tell_City"
    },
    {
        value: "America/Indiana/Vevay",
        lable: "America/Indiana/Vevay"
    },
    {
        value: "America/Indiana/Vincennes",
        lable: "America/Indiana/Vincennes"
    },
    {
        value: "America/Indiana/Winamac",
        lable: "America/Indiana/Winamac"
    },
    {
        value: "America/Kentucky/Louisville",
        lable: "America/Kentucky/Louisville"
    },
    {
        value: "America/Kentucky/Monticello",
        lable: "America/Kentucky/Monticello"
    },
    {
        value: "America/North_Dakota/Beulah",
        lable: "America/North_Dakota/Beulah"
    },
    {
        value: "America/North_Dakota/Center",
        lable: "America/North_Dakota/Center"
    },
    {
        value: "America/North_Dakota/New_salem",
        lable: "America/North_Dakota/New_salem"
    },
    {
        value: "Arizona",
        lable: "Arizona"
    },
    {
        value: "Central Time (US & Canada)",
        lable: "Central Time (US & Canada)"
    },
    {
        value: "Eastern Time (US & Canada)",
        lable: "Eastern Time (US & Canada)"
    },
    {
        value: "Guam",
        lable: "Guam"
    },
    {
        value: "Hawaii",
        lable: "Hawaii"
    },
    {
        value: "Indiana (East)",
        lable: "Indiana (East)"
    },
    {
        value: "Mountain Time (US & Canada)",
        lable: "Mountain Time (US & Canada)"
    },
    {
        value: "Spacific Time (US & Canada)",
        lable: "Spacific Time (US & Canada)"
    },
];